import customersApi from '../_api'
import { cloneDeep, forEach, isEqual } from 'lodash-es'
import i18n from '@/locales/'

export default {
  createCustomer: async ({ getters, commit, dispatch }, customer) => {
    if (getters.isCallingCustomers) return
    try {
      commit('setIsCallingCustomers', true)
      await customersApi.postCustomer(customer)
      commit('setIsCallingCustomers', false)
      dispatch('fetchCustomers')
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('customer_action_create_customer_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'customer_action_create_customer_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCustomers', false)
    }
  },
  fetchCustomers: async ({ getters, commit, dispatch }, pagination = false) => {
    if (getters.isCallingCustomers) return
    try {
      const page = getters.currentPage
      const filters = getters.filters
      commit('setIsCallingCustomers', true)
      const response = await customersApi.getCustomers(page, pagination, filters)
      const lastPage = response.headers['pagination-last-page']
      commit('setCustomersLastPage', lastPage)
      commit('setCustomersTotalItems', response.headers['pagination-total-items'])
      commit('setCustomers', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'customer_action_fetch_customers_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCustomers', false)
    }
  },
  updateCustomer: async ({ getters, commit, dispatch }, newCustomerData) => {
    if (getters.isCallingCustomers) return
    try {
      commit('setIsCallingCustomers', true)
      const { id } = newCustomerData
      const response = await customersApi.putCustomer(id, newCustomerData)
      commit('updateCustomer', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('customer_action_update_customer_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'customer_action_update_customer_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingCustomers', false)
    }
  },
  nextCustomerPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingCustomers) return
    commit('incrementCustomersCurrentPage')
    dispatch('fetchCustomers')
  },
  archiveCustomer: async ({ getters, commit, dispatch }, customerId) => {
    if (getters.isCallingCustomers) return
    try {
      commit('setIsCallingCustomers', true)
      const response = await customersApi.archiveCustomer(customerId)
      commit('updateCustomer', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('customer_action_archive_customer_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'customer_action_archive_customer_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCustomers', false)
    }
  },
  activateCustomer: async ({ getters, commit, dispatch }, customerId) => {
    if (getters.isCallingCustomers) return
    try {
      commit('setIsCallingCustomers', true)
      const response = await customersApi.activateCustomer(customerId)
      commit('updateCustomer', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('customer_action_activate_customer_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'customer_action_activate_customer_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCustomers', false)
    }
  },
  setCustomersFilters: async ({ commit, getters, dispatch }, filters) => {
    if (!isEqual(filters, getters.filters)) {
      commit('setCustomersFilters', filters)
      await dispatch('fetchCustomers')
    }
  },
  addCustomerFilters: ({ dispatch, getters }, newFilters) => {
    var currentFilters = cloneDeep(getters.filters)
    forEach(currentFilters, (e, k) => {
      const parts = k.split('[')
      if (parts.length === 1) return
      var searchedKey = parts[0]
      forEach(newFilters, (f, l) => {
        if (l.includes(searchedKey)) {
          delete currentFilters[k]
        }
      })
    })
    let mergeFilters = { ...currentFilters, ...newFilters }
    mergeFilters = forEach(mergeFilters, (e, k) => {
      if (e == null) {
        delete mergeFilters[k]
      }
    })
    dispatch('setCustomersFilters', mergeFilters)
  },
  sortCustomersByField: ({ dispatch, getters, commit }, { fieldName, direction = 'TOGGLE' }) => {
    const fields = Array.isArray(fieldName) ? fieldName : [fieldName]
    let newFilters = {}
    fields.forEach(el => {
      const order = `order[${el}]`
      if (direction === 'TOGGLE') {
        direction = getters.filters[order] === 'DESC' ? 'ASC' : 'DESC'
      }
      newFilters[order] = direction
    })
    dispatch('addCustomerFilters', newFilters)
  },
  clearCustomers: ({ commit }) => {
    commit('clearCustomers')
  },

  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }

}
